(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var WHATSAPP_URL = 'https://wa.me/918669791655';
  var closeAllMenus = function () {};

  /* ---------- shared sheet plumbing (location dialog + contact sheet) ---------- */
  var lockCount = 0;

  function lockScroll() {
    lockCount += 1;
    root.classList.add('ab-lock');
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) root.classList.remove('ab-lock');
  }

  function isModal(dialog) {
    return !!dialog && typeof dialog.showModal === 'function';
  }

  function finishClose(dialog) {
    unlockScroll();
    var back = dialog.__abReturn;
    dialog.__abReturn = null;
    if (back && typeof back.focus === 'function' && doc.contains(back)) back.focus();
  }

  function openSheet(dialog, trigger) {
    if (!dialog || dialog.hasAttribute('open')) return;
    dialog.__abReturn = trigger || doc.activeElement;
    if (isModal(dialog)) {
      if (dialog.getAttribute('aria-modal') !== 'true') dialog.setAttribute('aria-modal', 'true');
      try { dialog.showModal(); } catch (error) {
        dialog.removeAttribute('aria-modal');
        dialog.setAttribute('open', '');
      }
    } else {
      dialog.removeAttribute('aria-modal');
      dialog.setAttribute('open', '');
    }
    lockScroll();
  }

  function closeSheet(dialog) {
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); finishClose(dialog); }
  }

  function wireSheet(dialog) {
    if (!dialog || dialog.__abWired) return;
    dialog.__abWired = true;
    dialog.addEventListener('close', function () { finishClose(dialog); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeSheet(dialog); /* backdrop click */
    });
  }

  /* Escape via the native dialog cancel path; fallback for builds without showModal. */
  doc.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = doc.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i += 1) {
      if (!isModal(open[i])) { event.preventDefault(); closeSheet(open[i]); return; }
    }
  });

  /* ---------- location dialog (existing honest selector, unchanged behaviour) ---------- */
  var locationDialog = doc.querySelector('[data-ab-location-dialog]');
  var locationOpen = doc.querySelector('[data-ab-location]');
  var locationSave = doc.querySelector('[data-ab-save]');
  var locationLabel = doc.querySelector('[data-ab-location-label]');
  var storageKey = 'agribasket_location';

  function readLocation() {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (error) { return null; }
  }

  function renderLocation() {
    var value = readLocation();
    if (value && value.state && locationLabel) locationLabel.textContent = value.city ? value.city + ', ' + value.state : value.state;
  }

  renderLocation();
  wireSheet(locationDialog);

  if (locationOpen && locationDialog) {
    locationOpen.addEventListener('click', function () { openSheet(locationDialog, locationOpen); });
  }

  if (locationSave && locationDialog) {
    locationSave.addEventListener('click', function () {
      var stateInput = locationDialog.querySelector('[data-ab-state]');
      var cityInput = locationDialog.querySelector('[data-ab-city]');
      var pinInput = locationDialog.querySelector('[data-ab-pincode]');
      var state = stateInput.value;
      var city = cityInput.value.trim();
      var pin = pinInput.value.trim();
      if (!state) { stateInput.focus(); return; }
      if (!city) { cityInput.setCustomValidity('Enter your city or district'); cityInput.reportValidity(); return; }
      cityInput.setCustomValidity('');
      if (!/^[0-9]{6}$/.test(pin)) { pinInput.setCustomValidity('Enter a 6-digit Indian pincode'); pinInput.reportValidity(); return; }
      pinInput.setCustomValidity('');
      try { localStorage.setItem(storageKey, JSON.stringify({ state: state, city: city, pincode: pin })); } catch (error) {}
      renderLocation();
      closeSheet(locationDialog);
    });
  }

  /* ---------- reusable contact sheet: any [data-ab-contact-open] trigger ---------- */
  var contactSheet = doc.querySelector('[data-ab-contact-sheet]');
  var contactContext = doc.querySelector('[data-ab-contact-context]');
  var contactWhatsApp = doc.querySelector('[data-ab-contact-wa]');

  wireSheet(contactSheet);

  doc.addEventListener('click', function (event) {
    var node = event.target;
    if (!node || typeof node.closest !== 'function') return;

    var opener = node.closest('[data-ab-contact-open]');
    if (opener && contactSheet) {
      event.preventDefault();
      var context = (opener.getAttribute('data-ab-contact-context') || '').trim();
      if (contactContext) {
        contactContext.textContent = context;
        contactContext.hidden = context === '';
      }
      if (contactWhatsApp) contactWhatsApp.href = context ? WHATSAPP_URL + '?text=' + encodeURIComponent(context) : WHATSAPP_URL;
      openSheet(contactSheet, opener);
      return;
    }

    if (node.closest('[data-ab-contact-close]')) {
      event.preventDefault();
      closeSheet(contactSheet);
    }
  });

  /* ---------- desktop-only category dropdowns ---------- */
  var navList = doc.querySelector('[data-ab-nav]');
  var isDesktop = window.matchMedia ? function () { return window.matchMedia('(min-width: 750px)').matches; } : function () { return true; };

  if (navList) {
    var items = navList.querySelectorAll('[data-ab-nav-item]');
    var hoverTimer = null;

    var setOpen = function (item, state) {
      var trigger = item.querySelector('[data-ab-nav-trigger]');
      if (state) item.classList.add('is-open');
      else item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    };

    closeAllMenus = function () {
      for (var i = 0; i < items.length; i += 1) setOpen(items[i], false);
    };

    var closeOthers = function (keep) {
      for (var i = 0; i < items.length; i += 1) if (items[i] !== keep) setOpen(items[i], false);
    };

    for (var index = 0; index < items.length; index += 1) {
      (function (item) {
        var trigger = item.querySelector('[data-ab-nav-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          var keyboard = event.detail === 0;
          var willOpen = keyboard ? !item.classList.contains('is-open') : true;
          closeOthers(item);
          setOpen(item, willOpen);
        });

        item.addEventListener('mouseenter', function () {
          if (!isDesktop()) return;
          if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
          closeOthers(item);
          setOpen(item, true);
        });

        item.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          hoverTimer = setTimeout(function () { setOpen(item, false); }, 140);
        });

        item.addEventListener('focusin', function () {
          if (!isDesktop()) return;
          closeOthers(item);
          setOpen(item, true);
        });

        item.addEventListener('focusout', function () {
          setTimeout(function () { if (!item.contains(doc.activeElement)) setOpen(item, false); }, 0);
        });

        item.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          setOpen(item, false);
          trigger.focus();
        });
      }(items[index]));
    }

    doc.addEventListener('click', function (event) {
      var node = event.target;
      if (node && typeof node.closest === 'function' && node.closest('[data-ab-nav]')) return;
      closeAllMenus();
    });

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 750px)');
      var onBreakpoint = function () { if (!mq.matches) closeAllMenus(); };
      if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
      else if (mq.addListener) mq.addListener(onBreakpoint);
    }
  }

  /* ---------- scroll-return stickiness (preserved) ---------- */
  /* ---------- mobile navigation drawer ---------- */
  var drawer = doc.querySelector('[data-ab-drawer]');
  var drawerToggle = doc.querySelector('[data-ab-drawer-open]');
  var drawerPanel = drawer ? drawer.querySelector('.ab-drawer__panel') : null;
  var drawerIsOpen = false;
  var drawerReturn = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  /* Only visible nodes: collapsed <details> children report a null offsetParent. */
  function drawerFocusable() {
    if (!drawerPanel) return [];
    var nodes = drawerPanel.querySelectorAll(FOCUSABLE);
    var list = [];
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].offsetParent !== null) list.push(nodes[i]);
    }
    return list;
  }

  function openDrawer() {
    if (!drawer || drawerIsOpen) return;
    drawerIsOpen = true;
    closeAllMenus();
    drawerReturn = drawerToggle;
    drawer.classList.add('is-open');
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    if (drawerPanel) drawerPanel.focus();
  }

  function closeDrawer(restoreFocus) {
    if (!drawer || !drawerIsOpen) return;
    drawerIsOpen = false;
    drawer.classList.remove('is-open');
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    var back = drawerReturn;
    drawerReturn = null;
    if (restoreFocus !== false && back && typeof back.focus === 'function' && doc.contains(back)) back.focus();
  }

  if (drawer && drawerToggle) {
    drawerToggle.addEventListener('click', function () {
      if (drawerIsOpen) closeDrawer(true);
      else openDrawer();
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || typeof node.closest !== 'function') return;
      if (node.closest('[data-ab-drawer-close]')) { event.preventDefault(); closeDrawer(true); return; }
      /* Links close the drawer so a bfcache restore never shows it still open. */
      if (node.closest('a[href]')) closeDrawer(false);
    });
  }

  doc.addEventListener('keydown', function (event) {
    if (!drawerIsOpen) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(true); return; }
    if (event.key !== 'Tab' || !drawerPanel) return;
    var items = drawerFocusable();
    if (!items.length) { event.preventDefault(); drawerPanel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = doc.activeElement;
    if (event.shiftKey) {
      if (active === first || !drawerPanel.contains(active)) { event.preventDefault(); last.focus(); }
    } else if (active === last || active === drawerPanel) {
      event.preventDefault();
      first.focus();
    }
  });

  /* The drawer is a mobile control: growing past the breakpoint must release the
     scroll lock and the focus trap instead of leaving them behind. */
  if (window.matchMedia) {
    var drawerQuery = window.matchMedia('(min-width: 750px)');
    var onDrawerQuery = function () { if (drawerQuery.matches) closeDrawer(false); };
    if (drawerQuery.addEventListener) drawerQuery.addEventListener('change', onDrawerQuery);
    else if (drawerQuery.addListener) drawerQuery.addListener(onDrawerQuery);
  }

  var header = doc.querySelector('[data-ab-header]');
  if (header) {
    var wrapper = header.closest('.shopify-section-group-header-group') || header;
    var last = window.scrollY;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var now = window.scrollY;
        if (now < 80 || now < last - 4) {
          wrapper.classList.remove('ab-hidden');
        } else if (now > 150 && now > last + 8) {
          wrapper.classList.add('ab-hidden');
          closeAllMenus();
        }
        last = now;
        ticking = false;
      });
    }, { passive: true });
  }
})();
